export default {"src":"/frontend-static/_next/static/media/mastercardLight.9bc6ea42.svg","height":60,"width":100,"blurWidth":0,"blurHeight":0};